import { inLatamOrder } from "./market";

/**
 * Há cartão pronto para cobrar? (modo Global exige.)
 * Quem decide é o backend (`user_gateway.card_connected`, mesma regra que
 * libera o Global na API) — não reimplemente por marca aqui.
 */
export function hasConnectedCard(list) {
    return (list || []).some((it) => it.user_gateway?.card_connected === true);
}

/**
 * Cartão conectado cujo escopo cobre o bot (global, ou o bot está em
 * scoped_bot_ids). Mesma regra do backend (GatewayResolverService).
 */
export function cardCoversBot(list, botId) {
    return (list || []).some((it) => {
        const ug = it.user_gateway || {};
        if (ug.card_connected !== true) return false;
        if ((ug.scope || "global") !== "specific") return true;
        return (ug.scoped_bot_ids || []).map(String).includes(String(botId));
    });
}

/**
 * Países do LATAM que os gateways conectados cobram por pagamento local neste
 * bot (XPag...), sem repetir, na ordem dos países. Vazio = o modo LATAM
 * não ativa. `user_gateway.local_currencies` vem do backend (mesma regra do
 * GatewayResolverService) — não reimplemente por marca aqui.
 */
export function latamCurrenciesForBot(list, botId) {
    const covering = (list || []).filter((it) => {
        const ug = it.user_gateway || {};
        if (ug.card_connected !== true) return false;
        if ((ug.scope || "global") !== "specific") return true;
        return (ug.scoped_bot_ids || []).map(String).includes(String(botId));
    });
    return inLatamOrder(covering.flatMap((it) => it.user_gateway.local_currencies || []));
}

export const ONLY_UPSELL_BLOCKED_HINT = "Indisponível em bot Global ou com cartão";

/**
 * "Apenas Upsell" bloqueada? (espelha src/services/delivery/delivery_rules.py)
 * Bot em modo Global OU cartão conectado cobrindo algum dos bots (disparo:
 * vários bots — basta um).
 */
export function isOnlyUpsellBlocked({ currencyMode, gateways, botIds, isAdmin = false }) {
    if (isAdmin) return false; // admin pode com qualquer pagamento (mesma regra do backend)
    if (currencyMode === "mxn") return false; // LATAM: só pagamento local, sem chargeback
    if (currencyMode === "usd") return true;
    return (botIds || []).some((id) => cardCoversBot(gateways, id));
}

/** Desabilita a opção only_upsell (com o motivo) quando bloqueada. */
export function applyOnlyUpsellRule(options, blocked) {
    if (!blocked) return options;
    return options.map((o) => (o.value === "only_upsell"
        ? { ...o, disabled: true, hint: ONLY_UPSELL_BLOCKED_HINT }
        : o));
}
